export default __webpack_public_path__ + "static/media/MicrosoftTeams-image.56358972.png";